import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Params, Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerService } from '../retailer.service';
import { CurrencyPipe, formatDate } from '@angular/common';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AdminViewService } from 'src/app/framework/services/admin-view.service';
const helper = new JwtHelperService();

@Component({
  selector: 'app-all-retailers',
  templateUrl: './all-retailers.component.html',
  styleUrls: ['./all-retailers.component.scss'],
  providers: [CurrencyPipe]
})
export class AllRetailersComponent extends FeaturesBaseComponent implements OnInit {

  columnDefs
  rowData: any = [];
  rowSelection: string;
  private gridApi;
  private gridColumnApi;
  searchValue;
  showUpdateRetailer: boolean = false;
  selectedRows: any;
  griddata: any = [];
  retailerId: any;
  userRole:any;
  isButtonDisabled:boolean
  constructor(private router: Router, private retailerService: RetailerService, private currencyPipe: CurrencyPipe, private adminViewServices:AdminViewService) {
    super();
    this.retailerService.getretailerGrid().subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        var griddata = new Array();
        resData.forEach(element => {
          //;
          griddata.push({
            retailerId: element.retailerDetails.retailerId,
            retailerAccountNum: element.retailerAccountNum,
            retailerType: element.retailerDetails.retailerType,
            retailerStatus: element.retailerDetails.retailerStatus,
            businessName: element.retailerDetails.businessName,
            dbaName: element.retailerDetails.dbaName,
            invoiceType: element.invoiceType,
            salesRepName: element.salesRepName,
            businessNumber: element.retailerDetails.businessNumber,
            otpMobileNumber:element.retailerDetails.otpMobileNumber,
            language: element.retailerDetails.language,
            address1: element.retailerDetails.address1,
            city: element.retailerDetails.city,
            state: element.retailerDetails.state,
            tierLevel: element.retailerDetails.tierLevel,
            customerSince: formatDate(element.retailerDetails.customerSince, 'MM/dd/yyyy', 'en'),
            //customerSince: element.retailerDetails.customerSince,
            email: element.retailerDetails.email,
            currentAmount: element.currentAmount,
            retailerPriceList: element.retailerPriceList
          })
        });
        //let griddata = resData.retailerDetails;
        //
        this.setGrid(griddata);
      }
    })

          
  }

  ngOnInit(): void {
     this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })
  }

  setGrid(data: any) {

    this.columnDefs = [
      { field: 'retailerId', headerName: 'retailerId', width: 0, hide: true, sort: "desc" },
      { field: 'null', headerName: 'Action', width: 150, checkboxSelection: true },
      { field: 'retailerAccountNum', headerName: 'Account #', width: 150 },
      { field: 'invoiceType', headerName: 'Invoice Type', width: 180 },
      { field: 'retailerStatus', headerName: 'Status', width: 160 },
      { field: 'tierLevel', headerName: 'Tier Level', width: 160 },
      { field: 'businessName', headerName: 'Retailer Name', width: 200 },
      { field: 'dbaName', headerName: 'DBA Name', width: 180 },
      { field: 'salesRepName', headerName: 'Sales Rep/Dist', width: 200 },
      { field: 'language', headerName: 'Retailer Language', width: 210 },
      { field: 'businessNumber', headerName: 'Phone No', width: 200 },
      { field: 'otpMobileNumber', headerName: 'Retailer Mobile Number', width: 250 },
      { field: 'address1', headerName: 'Street Name', width: 180 },
      { field: 'city', headerName: 'City', width: 160 },
      { field: 'state', headerName: 'State', width: 130 },
      { field: 'customerSince', headerName: 'Customer Since', width: 200 },
      { field: 'retailerType', headerName: 'Account Type', width: 180 },
      { field: 'retailerPriceList', headerName: 'Price List', width: 200 },
      { field: 'email', headerName: 'Email Id', width: 180 },
      {
        field: 'currentAmount', headerName: 'Balance', width: 150, pinned: 'right', cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value)

        }
      }

    ]
    this.rowData = data;
    this.rowSelection = 'single';
  }


  onSelectionChanged(e) {

    this.selectedRows = this.gridApi.getSelectedRows();

    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length > 0) {
      this.showUpdateRetailer = true;
      this.retailerId = this.selectedRows[0].retailerId;

      return
    }
    this.showUpdateRetailer = false;
  }



  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  exportData() {
    var params = {
      fileName: "Retailers.csv",
      columnKeys: ['retailerId', 'retailerAccountNum', 'invoiceType','retailerStatus' ,'tierLevel', 'businessName', 'dbaName', 'salesRepName', 'language', 'businessNumber','otpMobileNumber', 'address1', 'city', 'state', 'customerSince', 'retailerType', 'retailerPriceList','email', 'currentAmount']
    //  columnKeys: ['retailerId', 'retailerAccountNum', 'retailerType', 'invoiceType','retailerStatus', 'tierLevel', 'businessName', 'dbaName', 'retailerPriceList', 'salesRepName', 'businessNumber', 'address1', 'city', 'state', 'customerSince', 'email', 'currentAmount']
    };
    //params.columnKeys = ["retailerId"];
    this.gridApi.exportDataAsCsv(params);
  }


  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

}